import { publicationApi } from 'apiConnector/discover';
import { SeeMorePublicationsContainer } from 'components/discover/publications/see-more/see-more-publications-container';
import { SeeMoreProductsSkeleton } from 'components/discover/publications/see-more/skeletons/skeletons';
import { FC, useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

import { LoadingSkeleton } from './loading-skeleton';
import { PublicationContainer } from './publication-container';

export const Products: FC<{ enableSeeMore: boolean; theme: SgBsTheme }> = ({ enableSeeMore, theme }) => {
  const trackOpen = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Open Product publication');
  }, []);
  const trackSlide = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Slide Product publication');
  }, []);

  const onSeeMore = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'See more Product publication');
  }, []);

  return (
    <PublicationContainer
      api={publicationApi.fetchProducts}
      titleKey="discover.products.title"
      errorKey="discover.products.error"
      soonKey="discover.products.soon"
      publishedKey="discover.products.published"
      seeMoreKey="discover.products.seeMore"
      id="products"
      skeleton={<LoadingSkeleton id="products" hasContent hasPlayButton={false} />}
      trackOpen={trackOpen}
      trackSlide={trackSlide}
      onSeeMore={onSeeMore}
      seeMoreModalContent={
        enableSeeMore
          ? onClose => (
              <SeeMorePublicationsContainer
                onClose={onClose}
                theme={theme}
                api={publicationApi.fetchMoreProducts}
                allKey="discover.products.all"
                titleKey="discover.products.title"
                skeleton={<SeeMoreProductsSkeleton />}
                modalContentType="products"
              />
            )
          : undefined
      }
      seeMoreModalE2e="see-more-products-modal"
    />
  );
};
